import React from "react";
import ResultChart from "./ResultChart";
import { IProfile } from "../../store/repIQPresetProfile/types";

interface IProps {
    data: any;
    isAnalysing: boolean;
    selectedPresetProfile: IProfile;
}

const ReputationScannerTestResult: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            {props.isAnalysing ? (
                <div className="box loading"></div>
            ) : (
                <React.Fragment>
                    <h3 className="content-sub-title">Test Conclusion</h3>

                    <ul className="test-traits">
                        <li>
                            <ResultChart
                                title={"Agreeableness"}
                                name={"agreeableness"}
                                data={Math.round(props.data.agreeableness * 100)}
                                profileName={props.selectedPresetProfile?.profileName}
                                rangeHigh={props.selectedPresetProfile?.categories?.Agreeableness?.high}
                                rangeLow={props.selectedPresetProfile?.categories?.Agreeableness?.low}
                                tooltip={"Agreeableness describes your tendency to put the needs of others ahead of your own needs."}
                                hasCTAButton={false}
                            />
                        </li>
                        <li>
                            <ResultChart
                                title={"Conscientiousness"}
                                name={"conscientiousness"}
                                data={Math.round(props.data.conscientiousness * 100)}
                                profileName={props.selectedPresetProfile?.profileName}
                                rangeHigh={props.selectedPresetProfile?.categories?.Conscientiousness?.high}
                                rangeLow={props.selectedPresetProfile?.categories?.Conscientiousness?.low}
                                tooltip={"Conscientiousness describes your tendency to focus on achieving your goals."}
                                hasCTAButton={false}
                            />
                        </li>
                        <li>
                            <ResultChart
                                title={"Emotional Range"}
                                name={"emotional-range"}
                                data={Math.round(props.data.emotionalRange * 100)}
                                profileName={props.selectedPresetProfile?.profileName}
                                rangeHigh={props.selectedPresetProfile?.categories?.EmotionalRange?.high}
                                rangeLow={props.selectedPresetProfile?.categories?.EmotionalRange?.low}
                                tooltip={"Emotional Range describes your susceptibility to stress and negative emotions."}
                                hasCTAButton={false}
                            />
                        </li>
                        <li>
                            <ResultChart
                                title={"Openness to Experiences"}
                                name={"openness-to-experiences"}
                                data={Math.round(props.data.opennessToExperiences * 100)}
                                profileName={props.selectedPresetProfile?.profileName}
                                rangeHigh={props.selectedPresetProfile?.categories?.OpennessToExperiences?.high}
                                rangeLow={props.selectedPresetProfile?.categories?.OpennessToExperiences?.low}
                                tooltip={"Openness to Experiences describes your tendency to try new things and think in abstract ways."}
                                hasCTAButton={false}
                            />
                        </li>
                        <li>
                            <ResultChart
                                title={"Extraversion"}
                                name={"extraversion"}
                                data={Math.round(props.data.extraversion * 100)}
                                profileName={props.selectedPresetProfile?.profileName}
                                rangeHigh={props.selectedPresetProfile?.categories?.Extraversion?.high}
                                rangeLow={props.selectedPresetProfile?.categories?.Extraversion?.low}
                                tooltip={"Extraversion describes your tendency to be energized by social interactions. "}
                                hasCTAButton={false}
                            />
                        </li>
                    </ul>

                    <div className="personality-legend">
                        <ul className="list-reset list-inline text-align-center">
                            <li className="margin-right-m">
                                <span className="key-score"></span> Your Score out of 100
                            </li>
                            <li className="profile-benchmark">
                                <span className="key-profile"></span> Preset Profile Benchmark
                            </li>
                        </ul>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};
export default ReputationScannerTestResult;
